import { Component, input } from '@angular/core';
import { AvatarComponent } from '@vendasta/galaxy/avatar';
import { User } from '@vendasta/iamv2';
import { CommonModule } from '@angular/common';
import { getFormattedDisplayName } from '../../../users.utility';

interface DisplayUser {
  name: string;
  profilePicture: string;
}

@Component({
  selector: 'meeting-analysis-attendee',
  imports: [CommonModule, AvatarComponent],
  template: `
    @if (displayUser) {
      <div class="user-header">
        <glxy-avatar
          [src]="showProfilePicture() ? displayUser.profilePicture : ''"
          [name]="displayUser.name"
          [width]="large() ? 32 : 18"
          [shape]="shape()"
        ></glxy-avatar>
        <div class="user-name">{{ displayUser.name }}</div>
      </div>
    } @else {
      <div class="user-header">
        <div class="skeleton-avatar stencil-shimmer"></div>
        <div class="skeleton-name stencil-shimmer"></div>
      </div>
    }
  `,
  styleUrls: ['./attendee.component.scss'],
})
export class AttendeeComponent {
  user = input<User | null>(null);
  shape = input<'circle' | 'square'>('circle');
  large = input<boolean>(false);
  showProfilePicture = input<boolean>(true);

  get displayUser(): DisplayUser | null {
    const userValue = this.user();
    if (!userValue) {
      return null;
    }
    return {
      name: getFormattedDisplayName(userValue),
      profilePicture: userValue.profileImageUrl || '',
    };
  }
}
